"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toaster = exports.showToast = exports.TOAST_EVENT = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
exports.TOAST_EVENT = 'mango:toast';
const EVENT = exports.TOAST_EVENT;
let nextId = 1;
function showToast(message, kind = 'success') {
    if (typeof window === 'undefined')
        return;
    window.dispatchEvent(new CustomEvent(EVENT, { detail: { message, kind } }));
}
exports.showToast = showToast;
const colors = {
    success: '#059669',
    error: '#dc2626',
    info: '#334155',
};
function Toaster({ bottomOffset = 24 }) {
    const [items, setItems] = (0, react_1.useState)([]);
    (0, react_1.useEffect)(() => {
        const onToast = (e) => {
            const { message, kind } = e.detail;
            const id = nextId++;
            // Don't stack the same message (e.g. several fields of one row saving in a row).
            setItems((prev) => [...prev.filter((t) => t.message !== message), { id, message, kind }].slice(-3));
            window.setTimeout(() => setItems((prev) => prev.filter((t) => t.id !== id)), kind === 'error' ? 5000 : 2000);
        };
        window.addEventListener(EVENT, onToast);
        return () => window.removeEventListener(EVENT, onToast);
    }, []);
    if (items.length === 0)
        return null;
    return ((0, jsx_runtime_1.jsx)("div", { "aria-live": "polite", style: {
            position: 'fixed',
            left: '50%',
            bottom: bottomOffset,
            transform: 'translateX(-50%)',
            zIndex: 12000,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 8,
            pointerEvents: 'none',
            width: 'max-content',
            maxWidth: 'calc(100vw - 32px)',
        }, children: items.map((t) => ((0, jsx_runtime_1.jsx)("div", { role: t.kind === 'error' ? 'alert' : 'status', style: {
                background: colors[t.kind],
                color: '#fff',
                padding: '10px 18px',
                borderRadius: 999,
                fontSize: 15,
                fontWeight: 600,
                boxShadow: '0 4px 14px rgba(0,0,0,0.25)',
            }, children: t.message }, t.id))) }));
}
exports.Toaster = Toaster;
exports.default = Toaster;
